<div class="adaptive-grow-1">
    <div class="fluent-container">
        <div class="title-color" *ngIf="!incidentselected">
            <h1>REGISTRAR INCIDENTE</h1>
        </div>
        <div class="title-color" *ngIf="incidentselected">
            <h1>EDITAR INCIDENTE</h1>
        </div>

        <mat-stepper linear #stepper>
            <div class="form-body">
                <mat-step [stepControl]="incidentForm">
                    <br />
                    <form [formGroup]="incidentForm">
                        <ng-template matStepLabel
                            >Información del incidente</ng-template
                        >
                        <fieldset>
                            <legend>
                                <h4>Detalles del incidente</h4>
                            </legend>
                            <div formArrayName="violence">
                                <div
                                    *ngFor="
                                        let violenceGroup of violence.controls;
                                        let i = index
                                    "
                                    [formGroupName]="i"
                                >
                                    <fieldset>
                                        <legend>
                                            <h4>
                                                Tipo de violencia {{ i + 1 }}
                                            </h4>
                                        </legend>

                                        <div class="line">
                                            <div
                                                class="column-md-4 column-lg-4 column-sm-6"
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                >
                                                    <mat-label
                                                        >Violencia</mat-label
                                                    >
                                                    <mat-select
                                                        matInput
                                                        placeholder="Violencia"
                                                        formControlName="name"
                                                        (selectionChange)="
                                                            onChangeViolence(i)
                                                        "
                                                    >
                                                        <mat-option
                                                            *ngFor="
                                                                let violence of violences
                                                            "
                                                            [value]="
                                                                violence.value
                                                            "
                                                            [disabled]="
                                                                isViolenceSelected(
                                                                    violence.value,
                                                                    i
                                                                )
                                                            "
                                                        >
                                                            {{ violence.value }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        *ngIf="
                                                            incidentForm
                                                                .get('name')
                                                                ?.hasError(
                                                                    'required'
                                                                )
                                                        "
                                                    >
                                                        Campo obligatorio
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div
                                                class="column-md-4 column-lg-4 column-sm-6"
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                >
                                                    <mat-label
                                                        >Tipo de
                                                        violencia</mat-label
                                                    >

                                                    <mat-select
                                                        multiple
                                                        placeholder="Tipo de violencia"
                                                        formControlName="violenceType"
                                                    >
                                                        <mat-option
                                                            *ngFor="
                                                                let valueType of getViolenceTypesForIndex(
                                                                    i
                                                                )
                                                            "
                                                            [value]="
                                                                valueType.id
                                                            "
                                                        >
                                                            {{ valueType.name }}
                                                        </mat-option>
                                                    </mat-select>

                                                    <mat-error
                                                        class="for-text text-danger"
                                                        *ngIf="
                                                            violenceGroup
                                                                .get(
                                                                    'violenceType'
                                                                )
                                                                ?.hasError(
                                                                    'required'
                                                                )
                                                        "
                                                    >
                                                        Campo obligatorio
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div
                                                class="column-md-3 column-lg-3 column-sm-3"
                                            >
                                                <button
                                                    class="secondary-button"
                                                    type="button"
                                                    (click)="removeViolence(i)"
                                                >
                                                    <span
                                                        class="button-content"
                                                    >
                                                        <mat-icon
                                                            fontIcon="delete"
                                                        ></mat-icon>
                                                        Eliminar {{ i + 1 }}
                                                    </span>
                                                </button>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                            </div>

                            <div class="column-md-3 column-lg-3 column-sm-3">
                                <button
                                    class="primary-button"
                                    type="button"
                                    (click)="addViolence()"
                                >
                                    <span class="button-content">
                                        <mat-icon fontIcon="add"></mat-icon>
                                        Añadir violencia
                                    </span>
                                </button>
                            </div>
                            <br />

                            <div class="line">
                                <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label
                                            >Tipo de Afectación</mat-label
                                        >
                                        <mat-select
                                            placeholder="Tipo de afectación"
                                            formControlName="affectationKind"
                                        >
                                            <mat-option
                                                *ngFor="
                                                    let af of affectationKindIncident
                                                "
                                                [value]="af.value"
                                                >{{ af.value }}</mat-option
                                            >
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label
                                            >Relación con el
                                            conflicto</mat-label
                                        >
                                        <mat-select
                                            placeholder="Relación con el conflicto"
                                            formControlName="conflictRelated"
                                        >
                                            <mat-option
                                                *ngFor="
                                                    let value of conflictRelated
                                                "
                                                [value]="value.value"
                                                >{{ value.value }}</mat-option
                                            >
                                        </mat-select>
                                        <mat-error
                                            class="for-text text-danger"
                                            *ngIf="
                                                incidentForm
                                                    .get('conflictRelated')
                                                    ?.hasError('required')
                                            "
                                        >
                                            Campo obligatorioo
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <!-- <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                >
                                    <section class="select-checkbox">
                                        <mat-checkbox
                                            class="example-margin"
                                            formControlName="phisicAgression"
                                            >Agresión física.</mat-checkbox
                                        >
                                    </section>
                                </div> -->

                                <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                >
                                    <app-search-select
                                        [label]="'Municipio'"
                                        [placeholder]="'Municipio'"
                                        [preloadedList]="locations"
                                        [displayFnFn]="displayFn"
                                        formControlName="location"
                                        [returnObject]="true"
                                    >
                                    </app-search-select>
                                </div>
                            </div>

                            <div formGroupName="address">
                                <div class="line">
                                    <div
                                        class="column-md-4 column-lg-4 column-sm-6"
                                    >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Terrirorio</mat-label>
                                            <mat-select
                                                matInput
                                                placeholder="Territorio"
                                                formControlName="territory"
                                            >
                                                <mat-option
                                                    *ngFor="
                                                        let territories of territories
                                                    "
                                                    [value]="territories.label"
                                                >
                                                    {{ territories.label }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-error
                                                *ngIf="
                                                    incidentForm
                                                        .get(
                                                            'address.territory'
                                                        )
                                                        ?.hasError('required')
                                                "
                                            >
                                                Campo obligatorio
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div
                                        class="column-md-4 column-lg-4 column-sm-6"
                                    >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Vereda/barrio</mat-label>
                                            <input
                                                matInput
                                                placeholder="Vereda/Barrio"
                                                formControlName="street"
                                                oninput="
                                                    this.value =
                                                        this.value.toUpperCase()
                                                "
                                            />
                                            <mat-error
                                                *ngIf="
                                                    incidentForm
                                                        .get('address.street')
                                                        ?.hasError('required')
                                                "
                                            >
                                                Campo obligatorio
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div
                                        class="column-md-4 column-lg-4 column-sm-6"
                                    >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Número</mat-label>
                                            <input
                                                matInput
                                                placeholder="Número"
                                                formControlName="number"
                                            />
                                            <mat-error
                                                *ngIf="
                                                    incidentForm
                                                        .get('address.number')
                                                        ?.hasError('required')
                                                "
                                            >
                                                Campo obligatorio
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                    <div
                                        class="column-md-4 column-lg-4 column-sm-6"
                                    >
                                        <mat-form-field appearance="outline">
                                            <mat-label>Complemento</mat-label>
                                            <input
                                                matInput
                                                placeholder="Complemento"
                                                formControlName="complement"
                                                oninput="
                                                    this.value =
                                                        this.value.toUpperCase()
                                                "
                                            />
                                            <mat-error
                                                *ngIf="
                                                    incidentForm
                                                        .get(
                                                            'address.complement'
                                                        )
                                                        ?.hasError('required')
                                                "
                                            >
                                                Campo obligatorio
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div
                                        class="column-md-4 column-lg-4 column-sm-6"
                                    >
                                        <section class="select-checkbox">
                                            <mat-checkbox
                                                class="example-margin"
                                                formControlName="georeference"
                                                >Ingresar
                                                Georreferenciación.</mat-checkbox
                                            >
                                        </section>
                                    </div>
                                </div>
                                <div formGroupName="geoRef">
                                    <div class="line">
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                            *ngIf="
                                                incidentForm.get(
                                                    'address.georeference'
                                                )?.value === true
                                            "
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Latitud</mat-label>
                                                <input
                                                    matInput
                                                    type="text"
                                                    formControlName="latitude"
                                                    required
                                                />
                                                <mat-error
                                                    *ngIf="
                                                        incidentForm
                                                            .get(
                                                                'address.geoRef.latitude'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                            *ngIf="
                                                incidentForm.get(
                                                    'address.georeference'
                                                )?.value === true
                                            "
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Longitud</mat-label>
                                                <input
                                                    matInput
                                                    type="text"
                                                    formControlName="longitude"
                                                    required
                                                />
                                                <mat-error
                                                    *ngIf="
                                                        incidentForm
                                                            .get(
                                                                'address.geoRef.longitude'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="line">
                                <div
                                    class="ccolumn-md-4 column-lg-4 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label
                                            >¿Quién reporta el caso?</mat-label
                                        >
                                        <mat-select
                                            placeholder="¿Quién reporta el caso?"
                                            formControlName="witnessRelationship"
                                        >
                                            <mat-option
                                                *ngFor="let value of whoReports"
                                                [value]="value.value"
                                                >{{ value.value }}</mat-option
                                            >
                                        </mat-select>
                                        <mat-error
                                            class="for-text text-danger"
                                            *ngIf="
                                                incidentForm
                                                    .get('witnessRelationship')
                                                    ?.hasError('required')
                                            "
                                        >
                                            Campo obligatorioo
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>Fecha del suceso</mat-label>
                                        <input
                                            matInput
                                            [matDatepicker]="registeredAtpicker"
                                            placeholder="Fecha del suceso"
                                            formControlName="date"
                                            placeholder="dd/mm/aaaa"
                                        />
                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="registeredAtpicker"
                                        >
                                        </mat-datepicker-toggle>
                                        <mat-datepicker
                                            #registeredAtpicker
                                        ></mat-datepicker>
                                        <mat-error
                                            class="for-text text-danger"
                                            *ngIf="
                                                incidentForm
                                                    .get('date')
                                                    ?.hasError('required')
                                            "
                                        >
                                            Campo obligatorioo
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>Hora del suceso</mat-label>
                                        <input
                                            matInput
                                            type="time"
                                            formControlName="time"
                                        />

                                        <mat-error
                                            *ngIf="
                                                incidentForm
                                                    .get('time')
                                                    ?.hasError('required')
                                            "
                                        >
                                            Campo obligatorio
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div
                                    class="column-md-12 column-lg-12 column-sm-15"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label
                                            >Descripción del hecho</mat-label
                                        >
                                        <textarea
                                            name="description"
                                            matInput
                                            id="description"
                                            formControlName="description"
                                            placeholder="Descripción"
                                            oninput="
                                                this.value =
                                                    this.value.toUpperCase()
                                            "
                                        ></textarea>
                                        <mat-error class="for-text text-danger">
                                            Campo obligatorio
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </fieldset>

                        <fieldset>
                            <legend>
                                <h4>Acceso a la justicia</h4>
                            </legend>
                            <div class="line" formGroupName="complaint">
                                <div
                                    class="ccolumn-md-4 column-lg-4 column-sm-6"
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>¿Denunció?</mat-label>
                                        <mat-select
                                            placeholder="Denuncia"
                                            formControlName="subject"
                                        >
                                            <mat-option
                                                *ngFor="let value of subjets"
                                                [value]="value.value"
                                            >
                                                {{ value.value }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            class="for-text text-danger"
                                            *ngIf="
                                                incidentForm
                                                    .get('complaint.subject')
                                                    ?.hasError('required')
                                            "
                                        >
                                            Campo obligatorio
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                    *ngIf="
                                        incidentForm.get('complaint.subject')
                                            ?.value === 'NO'
                                    "
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>¿Por qué?</mat-label>
                                        <input
                                            matInput
                                            placeholder="Complemento"
                                            formControlName="description"
                                            oninput="
                                                this.value =
                                                    this.value.toUpperCase()
                                            "
                                        />
                                        <mat-error
                                            *ngIf="
                                                incidentForm
                                                    .get(
                                                        'complaint.description'
                                                    )
                                                    ?.hasError('required')
                                            "
                                        >
                                            Campo obligatorio
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                    *ngIf="
                                        incidentForm.get('complaint.subject')
                                            ?.value === 'SI'
                                    "
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label
                                            >¿Denunció ante quién?</mat-label
                                        >
                                        <mat-select
                                            placeholder="¿Denuncia ante quién?"
                                            formControlName="reportedTo"
                                        >
                                            <mat-option
                                                *ngFor="
                                                    let value of reportedToOptions
                                                "
                                                [value]="value.value"
                                            >
                                                {{ value.value }}
                                            </mat-option>
                                        </mat-select>
                                        <mat-error
                                            class="for-text text-danger"
                                            *ngIf="
                                                incidentForm
                                                    .get('complaint.reportedTo')
                                                    ?.hasError('required')
                                            "
                                        >
                                            Campo obligatorio
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                    *ngIf="
                                        incidentForm.get('complaint.subject')
                                            ?.value === 'SI'
                                    "
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>Medidas tomadas</mat-label>
                                        <input
                                            matInput
                                            placeholder="Complemento"
                                            formControlName="takenMeasures"
                                            oninput="
                                                this.value =
                                                    this.value.toUpperCase()
                                            "
                                        />
                                        <mat-error
                                            class="for-text text-danger"
                                            *ngIf="
                                                incidentForm
                                                    .get(
                                                        'complaint.takenMeasures'
                                                    )
                                                    ?.hasError('required')
                                            "
                                        >
                                            Campo obligatorio
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div
                                    class="column-md-4 column-lg-4 column-sm-6"
                                    *ngIf="
                                        incidentForm.get('complaint.subject')
                                            ?.value === 'SI'
                                    "
                                >
                                    <mat-form-field appearance="outline">
                                        <mat-label>Fecha de denuncia</mat-label>
                                        <input
                                            matInput
                                            [matDatepicker]="registeredAtpicker"
                                            placeholder="Fecha de denuncia"
                                            formControlName="registeredAt"
                                            placeholder="dd/MM/aaaa"
                                        />
                                        <mat-datepicker-toggle
                                            matSuffix
                                            [for]="registeredAtpicker"
                                        ></mat-datepicker-toggle>
                                        <mat-datepicker
                                            #registeredAtpicker
                                        ></mat-datepicker>
                                        <mat-error
                                            class="for-text text-danger"
                                            *ngIf="
                                                outsiderForm
                                                    .get(
                                                        'complaint.registeredAt'
                                                    )
                                                    ?.hasError('required')
                                            "
                                        >
                                            Campo obligatorioo
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                        </fieldset>

                        <div formArrayName="witnesses">
                            <div
                                *ngFor="
                                    let witness of witnesses.controls;
                                    let i = index
                                "
                                [formGroupName]="i"
                            >
                                <fieldset>
                                    <legend>
                                        <h4>Testigo {{ i + 1 }}</h4>
                                    </legend>

                                    <div class="line">
                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <app-search-select
                                                [label]="
                                                    'Número de identificación'
                                                "
                                                [placeholder]="
                                                    'Número de identificación'
                                                "
                                                (itemSeleccionado)="
                                                    fillWitnessFields($event, i)
                                                "
                                                [searchFn]="searchPerson"
                                                [displayFnFn]="showPerson"
                                                [identifierFn]="
                                                    personIdentifier
                                                "
                                                formControlName="identificationCode"
                                            ></app-search-select>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Tipo de
                                                    identificación</mat-label
                                                >
                                                <mat-select
                                                    matInput
                                                    placeholder="Ingrese el documento"
                                                    formControlName="identificationType"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let i of identificationTypes
                                                        "
                                                        [value]="i.value"
                                                    >
                                                        {{ i.label }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        witness
                                                            .get(
                                                                'identificationType'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Nombres</mat-label>
                                                <input
                                                    matInput
                                                    placeholder="Nombres"
                                                    formControlName="name"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        witness
                                                            .get('name')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Apellidos</mat-label>
                                                <input
                                                    matInput
                                                    placeholder="Apellidos"
                                                    formControlName="lastName"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        witness
                                                            .get('lastName')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Teléfono</mat-label>
                                                <input
                                                    matInput
                                                    type="number"
                                                    placeholder="Teléfono"
                                                    formControlName="phone"
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        incidentForm
                                                            .get('phone')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <button
                                                class="secondary-button"
                                                type="button"
                                                (click)="removeWitness(i)"
                                            >
                                                <span class="button-content"
                                                    ><mat-icon
                                                        fontIcon="delete"
                                                    ></mat-icon
                                                    >Eliminar testigo
                                                    {{ i + 1 }}</span
                                                >
                                            </button>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                        <div>
                            <button
                                class="secondary-button"
                                [routerLink]="['/list-incident']"
                            >
                                <span class="button-content"
                                    ><mat-icon fontIcon="arrow_back"
                                        >arrow_back</mat-icon
                                    >
                                    Volver a la lista</span
                                >
                            </button>
                            <button
                                class="primary-button"
                                type="button"
                                (click)="addWitness()"
                            >
                                <span class="button-content"
                                    ><mat-icon fontIcon="add"></mat-icon>Añadir
                                    testigo</span
                                >
                            </button>

                            <button
                                class="secondary-button"
                                type="button"
                                matStepperNext
                            >
                                <span class="button-content"
                                    ><mat-icon
                                        fontIcon="keyboard_double_arrow_right"
                                    ></mat-icon
                                    >Siguiente</span
                                >
                            </button>
                        </div>
                    </form>
                </mat-step>

                <mat-step [stepControl]="outsiderForm" label="Víctimas">
                    <br />
                    <form [formGroup]="outsiderForm">
                        <ng-container
                            formArrayName="victimas"
                            *ngIf="victimas.controls.length > 0"
                        >
                            <div
                                *ngFor="
                                    let victim of victimas.controls;
                                    index as i
                                "
                                [formGroupName]="i"
                            >
                                <h4>Víctima {{ i + 1 }}</h4>
                                <fieldset>
                                    <legend>información general</legend>

                                    <div class="line">
                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <app-search-select
                                                [label]="
                                                    'Número de identificación'
                                                "
                                                [placeholder]="
                                                    'Número de identificación'
                                                "
                                                (itemSeleccionado)="
                                                    fillFields($event, i)
                                                "
                                                [searchFn]="searchPerson"
                                                [displayFnFn]="showPerson"
                                                [identifierFn]="
                                                    personIdentifier
                                                "
                                                formControlName="identificationCode"
                                            >
                                            </app-search-select>
                                        </div>
                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Tipo de
                                                    identificación</mat-label
                                                >
                                                <mat-select
                                                    matInput
                                                    placeholder="Ingrese el documento"
                                                    formControlName="identificationType"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let i of identificationTypes
                                                        "
                                                        [value]="i.value"
                                                        >{{
                                                            i.label
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get(
                                                                'identificationType'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Nombres</mat-label>
                                                <input
                                                    matInput
                                                    placeholder="Nombres"
                                                    formControlName="name"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('name')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Apellidos</mat-label>
                                                <input
                                                    matInput
                                                    placeholder="Apellidos"
                                                    formControlName="lastName"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('lastName')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Fecha de
                                                    nacimiento</mat-label
                                                >
                                                <input
                                                    matInput
                                                    [matDatepicker]="
                                                        birthDatepicker
                                                    "
                                                    formControlName="birthDate"
                                                    placeholder="DD/MM/AAAA"
                                                />
                                                <mat-datepicker-toggle
                                                    matSuffix
                                                    [for]="birthDatepicker"
                                                ></mat-datepicker-toggle>
                                                <mat-datepicker
                                                    #birthDatepicker
                                                ></mat-datepicker>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('birthDate')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorioo
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Edad</mat-label>
                                                <input
                                                    type="number"
                                                    matInput
                                                    placeholder="Edad"
                                                    formControlName="age"
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('age')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <app-search-select
                                                [label]="'Lugar de nacimiento'"
                                                [placeholder]="
                                                    'Lugar de nacimineto'
                                                "
                                                [preloadedList]="locations"
                                                [displayFnFn]="displayFn"
                                                [identifierFn]="idFn"
                                                formControlName="placeBirth"
                                                [returnObject]="true"
                                            >
                                            </app-search-select>
                                        </div>
                                    </div>

                                    <div
                                        class="line"
                                        formGroupName="socioeconomicStatus"
                                    >
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Estado civil</mat-label
                                                >
                                                <mat-select
                                                    matInput
                                                    placeholder="Estado civil"
                                                    formControlName="civilianStatus"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let c of civilStatus
                                                        "
                                                        [value]="c.value"
                                                        >{{
                                                            c.value
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get(
                                                                'civilianStatus'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="line">
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Género</mat-label>
                                                <mat-select
                                                    matInput
                                                    placeholder="Género"
                                                    formControlName="sex"
                                                >
                                                    <mat-option
                                                        *ngFor="let i of sex"
                                                        [value]="i.value"
                                                        >{{
                                                            i.label
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('sex')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Teléfono</mat-label>
                                                <input
                                                    matInput
                                                    type="number"
                                                    placeholder="Teléfono"
                                                    formControlName="phone"
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('phone')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Email</mat-label>
                                                <input
                                                    matInput
                                                    placeholder="Email"
                                                    formControlName="email"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        victim
                                                            .get('email')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        victim
                                                            .get('email')
                                                            ?.hasError(
                                                                'pattern'
                                                            )
                                                    "
                                                >
                                                    Ingrese un correo valido
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <div class="line" formGroupName="address">
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Terrirorio</mat-label
                                                >
                                                <mat-select
                                                    matInput
                                                    placeholder="Territorio"
                                                    formControlName="territory"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let territories of territories
                                                        "
                                                        [value]="
                                                            territories.label
                                                        "
                                                    >
                                                        {{ territories.label }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error
                                                    *ngIf="
                                                        incidentForm
                                                            .get(
                                                                'address.territory'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </fieldset>

                                <div formGroupName="education">
                                    <fieldset>
                                        <legend>Educación</legend>

                                        <div class="line">
                                            <div
                                                class="column-md-3 column-lg-3 column-sm-3"
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                >
                                                    <mat-label
                                                        >Nivel
                                                        educativo</mat-label
                                                    >
                                                    <mat-select
                                                        matInput
                                                        placeholder="Nivel educativo"
                                                        formControlName="level"
                                                    >
                                                        <mat-option
                                                            *ngFor="
                                                                let e of educationLevel
                                                            "
                                                            [value]="e.value"
                                                            >{{
                                                                e.value
                                                            }}</mat-option
                                                        >
                                                    </mat-select>
                                                    <mat-error
                                                        class="for-text text-danger"
                                                        *ngIf="
                                                            outsiderForm
                                                                .get('level')
                                                                ?.hasError(
                                                                    'required'
                                                                )
                                                        "
                                                    >
                                                        Campo obligatorio
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div
                                                class="column-md-3 column-lg-3 column-sm-3"
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                >
                                                    <mat-label
                                                        >Educación
                                                        propia</mat-label
                                                    >
                                                    <input
                                                        matInput
                                                        placeholder="Educación propia"
                                                        formControlName="culturalKnowledge"
                                                        oninput="
                                                            this.value =
                                                                this.value.toUpperCase()
                                                        "
                                                    />
                                                    <mat-error
                                                        class="for-text text-danger"
                                                        *ngIf="
                                                            outsiderForm
                                                                .get(
                                                                    'culturalKnowledge'
                                                                )
                                                                ?.hasError(
                                                                    'required'
                                                                )
                                                        "
                                                    >
                                                        Campo obligatorio
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div
                                                class="column-md-3 column-lg-3 column-sm-3"
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                >
                                                    <mat-label
                                                        >Nasa Yuwe</mat-label
                                                    >
                                                    <mat-select
                                                        matInput
                                                        placeholder="Nasa Yuwe"
                                                        formControlName="nasaYuwe"
                                                    >
                                                        <mat-option
                                                            *ngFor="
                                                                let e of lengueageProperty
                                                            "
                                                            [value]="e.value"
                                                            >{{
                                                                e.label
                                                            }}</mat-option
                                                        >
                                                    </mat-select>
                                                    <mat-error
                                                        class="for-text text-danger"
                                                        *ngIf="
                                                            outsiderForm
                                                                .get('nasaYuwe')
                                                                ?.hasError(
                                                                    'required'
                                                                )
                                                        "
                                                    >
                                                        Campo obligatorio
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div
                                                class="column-md-3 column-lg-3s column-sm-6"
                                            >
                                                <section
                                                    class="select-checkbox"
                                                >
                                                    <mat-checkbox
                                                        class="example-margin"
                                                        formControlName="isIlliterate"
                                                        >¿Es
                                                        analfabeta?</mat-checkbox
                                                    >
                                                </section>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>

                                <fieldset>
                                    <legend>Ocupación</legend>

                                    <div class="line" formGroupName="profesion">
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Ocupación</mat-label>
                                                <mat-select
                                                    matInput
                                                    placeholder="Ocupación"
                                                    formControlName="name"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let o of occupation
                                                        "
                                                        [value]="o.value"
                                                        >{{
                                                            o.value
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('name')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <!-- <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Nombre de la
                                                    compañía</mat-label
                                                >
                                                <input
                                                    matInput
                                                    placeholder="Nombre de la compañía"
                                                    formControlName="companyName"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('companyName')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div> -->

                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Tipo de lider</mat-label
                                                >
                                                <mat-select
                                                    matInput
                                                    placeholder="Tipo de lider"
                                                    formControlName="leaderRole"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let l of leadertype
                                                        "
                                                        [value]="l.value"
                                                        >{{
                                                            l.label
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('leaderRole')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div
                                        class="line"
                                        formGroupName="socioeconomicStatus"
                                    >
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Fuente de
                                                    ingresos</mat-label
                                                >
                                                <mat-select
                                                    matInput
                                                    placeholder="Fuente de ingresos"
                                                    formControlName="sourceIncome"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let l of sourceIncome
                                                        "
                                                        [value]="l.value"
                                                        >{{
                                                            l.value
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('sourceIncome')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <!-- <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >¿Cómo los
                                                    obtiene?</mat-label
                                                >
                                                <input
                                                    matInput
                                                    placeholder="¿Cómo los obtiene?"
                                                    formControlName="sourceIncomeMethod"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get(
                                                                'sourceIncomeMethod'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div> -->
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <app-search-select
                                                [label]="'Lugar donde labora'"
                                                [placeholder]="
                                                    'Lugar donde labora'
                                                "
                                                [preloadedList]="locations"
                                                [displayFnFn]="displayFn"
                                                formControlName="placeWork"
                                                [returnObject]="true"
                                            >
                                            </app-search-select>
                                        </div>
                                    </div>
                                </fieldset>

                                <div formGroupName="socialSecurity">
                                    <fieldset>
                                        <legend>Seguridad social</legend>

                                        <div class="line">
                                            <div
                                                class="column-md-4 column-lg-4 column-sm-6"
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                >
                                                    <mat-label>Eps</mat-label>
                                                    <mat-select
                                                        matInput
                                                        placeholder="Eps"
                                                        formControlName="eps"
                                                    >
                                                        <mat-option
                                                            *ngFor="
                                                                let eps of eps
                                                            "
                                                            [value]="eps.value"
                                                        >
                                                            {{ eps.value }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        class="for-text text-danger"
                                                        *ngIf="
                                                            outsiderForm
                                                                .get(
                                                                    'socialSecurity.eps'
                                                                )
                                                                ?.hasError(
                                                                    'required'
                                                                )
                                                        "
                                                    >
                                                        Campo obligatorio
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>

                                            <div
                                                class="column-md-4 column-lg-4 column-sm-6"
                                            >
                                                <mat-form-field
                                                    appearance="outline"
                                                >
                                                    <mat-label
                                                        >Regimen</mat-label
                                                    >
                                                    <mat-select
                                                        matInput
                                                        placeholder="Regimen"
                                                        formControlName="insuranceKind"
                                                    >
                                                        <mat-option
                                                            *ngFor="
                                                                let regimen of insuranceKind
                                                            "
                                                            [value]="
                                                                regimen.value
                                                            "
                                                        >
                                                            {{ regimen.value }}
                                                        </mat-option>
                                                    </mat-select>
                                                    <mat-error
                                                        class="for-text text-danger"
                                                        *ngIf="
                                                            outsiderForm
                                                                .get(
                                                                    'socialSecurity.insuranceKind'
                                                                )
                                                                ?.hasError(
                                                                    'required'
                                                                )
                                                        "
                                                    >
                                                        Campo obligatorio
                                                    </mat-error>
                                                </mat-form-field>
                                            </div>
                                            <div
                                                class="column-md-4 column-lg-4 column-sm-6"
                                            >
                                                <section
                                                    class="select-checkbox"
                                                >
                                                    <mat-checkbox
                                                        class="example-margin"
                                                        formControlName="hasInsurance"
                                                        >¿Tiene seguro?
                                                    </mat-checkbox>
                                                </section>
                                            </div>
                                        </div>
                                    </fieldset>
                                </div>
                                <fieldset>
                                    <legend>Información adicional</legend>

                                    <div
                                        class="line"
                                        formGroupName="socioeconomicStatus"
                                    >
                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Tipo de
                                                    discapacidad</mat-label
                                                >
                                                <mat-select
                                                    multiple
                                                    placeholder="Tipo de discapacidad"
                                                    formControlName="disability"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let l of disabilityTypes
                                                        "
                                                        [value]="l.value"
                                                        >{{
                                                            l.value
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        victim
                                                            .get(
                                                                'socioeconomicStatus.disability'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-3 column-lg-3 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Religión</mat-label>
                                                <mat-select
                                                    matInput
                                                    placeholder="Religión"
                                                    formControlName="religion"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let religion of religion
                                                        "
                                                        [value]="religion.value"
                                                    >
                                                        {{ religion.value }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('religion')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Grupo cultural o
                                                    étnico</mat-label
                                                >
                                                <mat-select
                                                    matInput
                                                    placeholder="Grupo cultural o étnico"
                                                    formControlName="culturaEthnic"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let etnias of ethnic
                                                        "
                                                        [value]="etnias.value"
                                                    >
                                                        {{ etnias.value }}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get(
                                                                'culturaEthnic'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Orientación
                                                    sexual</mat-label
                                                >
                                                <mat-select
                                                    matInput
                                                    placeholder="Orientación sexual"
                                                    formControlName="gender"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let o of sexualOrientation
                                                        "
                                                        [value]="o.value"
                                                        >{{
                                                            o.value
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('gender')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Número de hijos</mat-label
                                                >
                                                <input
                                                    type="number"
                                                    matInput
                                                    placeholder="Número de hijos"
                                                    formControlName="qtyChildren"
                                                    rows="3"
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('qtyChildren')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <section class="select-checkbox">
                                                <mat-checkbox
                                                    class="example-margin"
                                                    formControlName="isHeadOfHousehold"
                                                    >¿Es cabeza de
                                                    hogar?</mat-checkbox
                                                >
                                            </section>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <section class="select-checkbox">
                                                <mat-checkbox
                                                    class="example-margin"
                                                    formControlName="isConflictVictim"
                                                    >¿Es víctima del conflicto
                                                    armado?</mat-checkbox
                                                >
                                            </section>
                                        </div>
                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <section class="select-checkbox">
                                                <mat-checkbox
                                                    class="example-margin"
                                                    formControlName="hasProtectionScheme"
                                                    >¿Tiene esquema de
                                                    seguridad?</mat-checkbox
                                                >
                                            </section>
                                        </div>

                                        <div
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <section class="select-checkbox">
                                                <mat-checkbox
                                                    class="example-margin"
                                                    formControlName="ownsLand"
                                                    >¿Posee
                                                    tierra?</mat-checkbox
                                                >
                                            </section>
                                        </div>
                                        <div
                                            *ngIf="
                                                victim.get(
                                                    'socioeconomicStatus.ownsLand'
                                                )?.value
                                            "
                                            class="column-md-3 column-lg-3 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Área del terreno</mat-label
                                                >
                                                <input
                                                    type="number"
                                                    matInput
                                                    placeholder="Área del terreno"
                                                    formControlName="landArea"
                                                    rows="3"
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        outsiderForm
                                                            .get('landArea')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            *ngIf="
                                                victim.get(
                                                    'socioeconomicStatus.ownsLand'
                                                )?.value
                                            "
                                            class="column-md-3 column-lg-3 column-sm-3"
                                        >
                                            <section class="select-checkbox">
                                                <mat-checkbox
                                                    class="example-margin"
                                                    formControlName="isLandOwner"
                                                    >¿El terreno es
                                                    propio?</mat-checkbox
                                                >
                                            </section>
                                        </div>
                                    </div>
                                </fieldset>

                                <button
                                    (click)="deleteVictim(i)"
                                    type="button"
                                    class="secondary-button"
                                >
                                    <span class="button-content"
                                        ><mat-icon fontIcon="delete"></mat-icon
                                        >Eliminar Víctima {{ i + 1 }}</span
                                    >
                                </button>
                            </div>
                        </ng-container>

                        <button
                            (click)="addVictim()"
                            type="button"
                            class="primary-button"
                            style="margin-top: 1rem"
                        >
                            <span class="button-content"
                                ><mat-icon fontIcon="add"></mat-icon>Añadir
                                Víctima</span
                            >
                        </button>
                        <button
                            class="secondary-button"
                            type="button"
                            matStepperPrevious
                        >
                            <span class="button-content"
                                ><mat-icon
                                    fontIcon="keyboard_double_arrow_left"
                                ></mat-icon
                                >Anterior</span
                            >
                        </button>
                        <button
                            class="secondary-button"
                            type="button"
                            matStepperNext
                        >
                            <span class="button-content"
                                ><mat-icon
                                    fontIcon="keyboard_double_arrow_right"
                                ></mat-icon
                                >Siguiente</span
                            >
                        </button>
                    </form>
                </mat-step>

                <mat-step [stepControl]="secondOutsiderForm" label="Agresores">
                    <br />
                    <form [formGroup]="secondOutsiderForm">
                        <ng-container
                            formArrayName="agresores"
                            *ngIf="agresores.controls.length > 0"
                        >
                            <div
                                *ngFor="
                                    let agresores of agresores.controls;
                                    index as i
                                "
                                [formGroupName]="i"
                            >
                                <fieldset>
                                    <legend>
                                        <h4>Agresor {{ i + 1 }}</h4>
                                    </legend>
                                    <div class="line">
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <app-search-select
                                                [label]="
                                                    'Número de identificación'
                                                "
                                                [placeholder]="
                                                    'Número de identificación'
                                                "
                                                (itemSeleccionado)="
                                                    fillAggressorFields(
                                                        $event,
                                                        i
                                                    )
                                                "
                                                [searchFn]="searchPerson"
                                                [displayFnFn]="showPerson"
                                                [identifierFn]="
                                                    personIdentifier
                                                "
                                                formControlName="identificationCode"
                                            >
                                            </app-search-select>
                                        </div>

                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Tipo de
                                                    identificación</mat-label
                                                >
                                                <mat-select
                                                    matInput
                                                    placeholder="Tipo de identificación"
                                                    formControlName="identificationType"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let i of identificationTypes
                                                        "
                                                        [value]="i.value"
                                                        >{{
                                                            i.label
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        secondOutsiderForm
                                                            .get(
                                                                'identificationType'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Nombres</mat-label>
                                                <input
                                                    matInput
                                                    placeholder="Nombres"
                                                    formControlName="name"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        secondOutsiderForm
                                                            .get('name')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Apellidos</mat-label>
                                                <input
                                                    matInput
                                                    placeholder="Primer Apellido"
                                                    formControlName="lastName"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        secondOutsiderForm
                                                            .get('lastName')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>

                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Teléfono</mat-label>
                                                <input
                                                    matInput
                                                    type="number"
                                                    placeholder="Teléfono"
                                                    formControlName="phone"
                                                />
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        secondOutsiderForm
                                                            .get('phone')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Género</mat-label>
                                                <mat-select
                                                    matInput
                                                    placeholder="Género"
                                                    formControlName="sex"
                                                >
                                                    <mat-option
                                                        *ngFor="let i of sex"
                                                        [value]="i.value"
                                                        >{{
                                                            i.label
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        secondOutsiderForm
                                                            .get('sex')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div class="line" formGroupName="address">
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Vereda/barrio</mat-label
                                                >
                                                <input
                                                    matInput
                                                    placeholder="Vereda/Barrio"
                                                    formControlName="street"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    *ngIf="
                                                        incidentForm
                                                            .get(
                                                                'address.street'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label>Número</mat-label>
                                                <input
                                                    matInput
                                                    placeholder="Número"
                                                    formControlName="number"
                                                />
                                                <mat-error
                                                    *ngIf="
                                                        incidentForm
                                                            .get(
                                                                'address.number'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Complemento</mat-label
                                                >
                                                <input
                                                    matInput
                                                    placeholder="Complemento"
                                                    formControlName="complement"
                                                    oninput="
                                                        this.value =
                                                            this.value.toUpperCase()
                                                    "
                                                />
                                                <mat-error
                                                    *ngIf="
                                                        incidentForm
                                                            .get(
                                                                'address.complement'
                                                            )
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>

                                    <div
                                        class="line"
                                        [formGroup]="perpetrorsMetadata.at(i)"
                                    >
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Relación con la víctima
                                                </mat-label>
                                                <mat-select
                                                    matInput
                                                    placeholder="Relación con la víctima"
                                                    formControlName="relationship"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let p of relationship
                                                        "
                                                        [value]="p.value"
                                                        >{{
                                                            p.value
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        secondOutsiderForm
                                                            .get('relationship')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                        <div
                                            class="column-md-4 column-lg-4 column-sm-6"
                                        >
                                            <mat-form-field
                                                appearance="outline"
                                            >
                                                <mat-label
                                                    >Grupo presunto responsable
                                                </mat-label>
                                                <mat-select
                                                    matInput
                                                    placeholder="Grupo presunto responsable"
                                                    formControlName="organization"
                                                >
                                                    <mat-option
                                                        *ngFor="
                                                            let p of organizations
                                                        "
                                                        [value]="p.value"
                                                        >{{
                                                            p.value
                                                        }}</mat-option
                                                    >
                                                </mat-select>
                                                <mat-error
                                                    class="for-text text-danger"
                                                    *ngIf="
                                                        secondOutsiderForm
                                                            .get('organization')
                                                            ?.hasError(
                                                                'required'
                                                            )
                                                    "
                                                >
                                                    Campo obligatorio
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                </fieldset>

                                <div>
                                    <button
                                        (click)="deleteAgressor(i)"
                                        type="button"
                                        class="secondary-button"
                                    >
                                        <span class="button-content"
                                            ><mat-icon
                                                fontIcon="delete"
                                            ></mat-icon
                                            >Eliminar Agresor {{ i + 1 }}</span
                                        >
                                    </button>
                                </div>
                            </div>
                        </ng-container>
                        <button
                            (click)="addAgressor()"
                            type="button"
                            class="primary-button"
                            style="margin-top: 1rem"
                        >
                            <span class="button-content"
                                ><mat-icon fontIcon="add"></mat-icon>Añadir
                                Agresor</span
                            >
                        </button>
                        <button
                            class="secondary-button"
                            type="button"
                            matStepperPrevious
                        >
                            <span class="button-content"
                                ><mat-icon
                                    fontIcon="keyboard_double_arrow_left"
                                ></mat-icon
                                >Anterior</span
                            >
                        </button>
                        <button
                            class="secondary-button"
                            type="button"
                            matStepperNext
                        >
                            <span class="button-content"
                                ><mat-icon
                                    fontIcon="keyboard_double_arrow_right"
                                ></mat-icon
                                >Siguiente</span
                            >
                        </button>
                    </form>
                </mat-step>

                <mat-step [stepControl]="attachmentForm">
                    <form [formGroup]="attachmentForm">
                        <ng-template matStepLabel>Adjuntar archivo</ng-template>

                        <fieldset>
                            <legend>Sube tu archivo</legend>

                            <div class="form-group"></div>

                            <div class="file-container">
                                <button
                                    type="button"
                                    class="primary-button"
                                    (click)="openUploadModal()"
                                >
                                    <span class="button-content"
                                        ><mat-icon>upload</mat-icon> Cargar
                                        soporte</span
                                    >
                                </button>

                                <div
                                    *ngIf="selectedFile as f; else showExisting"
                                >
                                    <br />
                                    <a
                                        href
                                        (click)="
                                            openSelectedPdf();
                                            $event.preventDefault()
                                        "
                                        class="preview-wrapper"
                                    >
                                        <mat-icon inline>description</mat-icon>
                                        {{ f.name }}
                                    </a>
                                </div>

                                <ng-template #showExisting>
                                    <div
                                        *ngIf="
                                            incidentselected &&
                                                hasFile(incidentselected);
                                            else noFile
                                        "
                                    >
                                        <br />
                                        <a
                                            href
                                            (click)="
                                                openIncidentPdf();
                                                $event.preventDefault()
                                            "
                                            class="preview-wrapper"
                                        >
                                            <mat-icon inline
                                                >description</mat-icon
                                            >
                                            {{
                                                incidentselected.fileAttach
                                                    .fileName
                                            }}
                                        </a>
                                    </div>
                                    <ng-template #noFile>
                                        <div>
                                            <span
                                                >No hay soporte disponible</span
                                            >
                                        </div>
                                    </ng-template>
                                </ng-template>
                            </div>

                            <div
                                class="column-md-3 column-lg-2 column-sm-4"
                            ></div>
                        </fieldset>

                        <div class="mt-4">
                            <button
                                class="secondary-button"
                                type="button"
                                matStepperPrevious
                            >
                                <span class="button-content"
                                    ><mat-icon
                                        fontIcon="keyboard_double_arrow_left"
                                    ></mat-icon
                                    >Anterior</span
                                >
                            </button>
                            <button
                                type="button"
                                class="secondary-button"
                                matStepperNext
                            >
                                <span class="button-content"
                                    ><mat-icon
                                        fontIcon="keyboard_double_arrow_right"
                                    ></mat-icon
                                    >Siguiente</span
                                >
                            </button>
                        </div>
                    </form>
                </mat-step>
                <mat-step>
                    <ng-template matStepLabel>Guardar</ng-template>
                    <p>Hemos terminado.</p>
                    <div>
                        <button
                            class="secondary-button"
                            type="button"
                            matStepperPrevious
                        >
                            <span class="button-content"
                                ><mat-icon
                                    fontIcon="keyboard_double_arrow_left"
                                ></mat-icon
                                >Anterior</span
                            >
                        </button>
                        <button
                            type="submit"
                            class="primary-button"
                            (click)="saveAll()"
                        >
                            <span class="button-content"
                                ><mat-icon fontIcon="save"></mat-icon>Guardar
                                todo</span
                            >
                        </button>
                        <button
                            class="secondary-button"
                            type="button"
                            (click)="stepper.reset()"
                        >
                            <span class="button-content"
                                ><mat-icon fontIcon="autorenew"></mat-icon
                                >Reiniciar</span
                            >
                        </button>
                    </div>
                </mat-step>
            </div>
        </mat-stepper>
    </div>
</div>
